<template>
  <div
    class="modal fade"
    id="getAccessModal"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-content--access">
        <button
          type="button"
          class="modal-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <svg
            width="24"
            height="24"
          >
            <use href="/static/images/sprite/sprite.svg#close"></use>
          </svg>
        </button>
        <div class="modal-header">
          <h2 class="modal-title">{{ title }}</h2>
        </div>
        <div class="modal-body">
          <p
            class="text-center"
            v-html="text"
          ></p>
        </div>
        <div class="modal-footer">
          <a
            :href="$getSubdomainLink('payment', '/sign-up')"
            class="btn btn-primary"
          >
          Join now
          </a>
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="btn btn-outline"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ModalAccess",
    props: {
      title: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        required: true,
      },
    },
  };
</script>
